const EnumRole = Object.freeze({
  ADMIN: "ADMIN",
  TEACHER: "TEACHER",
  STUDENT: "STUDENT",
});

export default EnumRole;
